import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {getProductToReorderList} from './actions';
import {bindActionCreators} from "redux";
import {Report} from "../utils/report";
import {Divider, InputNumber} from "antd";
import moment from "moment/moment";

function suggestedQuantity(quantitySold, overPeriodInDays, daysToReorder) {
  if (!overPeriodInDays) return 0;
  return (((quantitySold / overPeriodInDays) * daysToReorder) + 0.49).toFixed();
}

const defaultPrint = x => x || '-';

const columns = [
  {
    title: 'Supplier',
    dataIndex: 'supplierName',
    key: 'supplierName',
    print: defaultPrint
  },
  {
    title: 'Product',
    dataIndex: 'productDisplay',
    key: 'productDisplay',
    print: defaultPrint
  },
  {
    title: 'Quantity in Stock',
    dataIndex: 'quantityInStock',
    key: 'quantityInStock',
    print: defaultPrint
  },
  {
    title: 'Quantity Sold',
    dataIndex: 'quantitySold',
    key: 'quantitySold',
    print: defaultPrint
  },
  {
    title: 'Over Period',
    dataIndex: 'overPeriodInDays',
    key: 'overPeriodInDays',
    render: value => <span>{value} day(s)</span>,
    print: defaultPrint
  },
  {
    title: 'Suggested Quantity',
    dataIndex: 'suggestedQuantity',
    key: 'suggestedQuantity',
    print: defaultPrint
  },
  {
    title: 'Suggested Quantity to Order',
    dataIndex: 'daysToReorder',
    key: 'toOrder',
    render: (_, record) => <span>{record.suggestedQuantity - record.quantityInStock}</span>,
    print: (_, record) => (record.suggestedQuantity - record.quantityInStock)
  }
];

class ProductToReorderListPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      daysToReorder: 14,
      transformData: this.dataTransformer(14),
    };
  }

  dataTransformer(daysToReorder) {
    return data => {
      return data.map((x) => {
        let overPeriodInDays = null;
        if (x.sinceDate) {
          overPeriodInDays = Math.ceil(moment().diff(x.sinceDate) / 86400000);
          if (overPeriodInDays < 7) overPeriodInDays = 7;
        }
        return {
          ...x,
          daysToReorder,
          overPeriodInDays,
          suggestedQuantity: suggestedQuantity(x.quantitySold, overPeriodInDays, daysToReorder)
        };
      });
    };
  }

  onDaysToReorderChange = daysToReorder => {
    this.setState({daysToReorder, transformData: this.dataTransformer(daysToReorder)});
  };

  render() {
    return <div>
      Reorder for&nbsp;
      <InputNumber value={this.state.daysToReorder}
                   onChange={this.onDaysToReorderChange} />
      &nbsp;days
      <Divider type="horizontal" />
      <Report title="Inventory Products to Reorder"
              readModelName="productToReorderList"
              rowKey="productId"
              columns={columns}
              filterProvider={() => ({
                where: {
                  salonId: {eq: this.props.salonId},
                },
                order: 'supplierName ASC, productDisplay ASC'
              })}
              transformData={this.state.transformData}
              printHeader={`Reorder for ${this.state.daysToReorder} days`} />;
    </div>
  }
}

ProductToReorderListPage.propTypes = {
  salonId: PropTypes.string.isRequired,
  productToReorderList: PropTypes.array.isRequired,
  getProductToReorderList: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  salonId: state.salon.selectedSalonId,
  productToReorderList: state.product.productToReorderList,
});

const mapDispatchToProps = dispatch => ({
  getProductToReorderList: bindActionCreators(getProductToReorderList, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductToReorderListPage);



// WEBPACK FOOTER //
// ./src/Product/ProductToReorderReport.js